<template>
  <div class="loader-bar" ref="bar"></div>
</template>
<style lang="scss" scoped>
  @import '../assets/scss/variables';

  .page-scanner {
    position: relative;
    z-index: 99;
  }

  .loader-bar{
    width: 0%;
    height: 10px;
    background-color: $primary;
    transition-property: 'width';
    transition-timing-function: linear;
    transition-duration: .2s;
    z-index: 99;
    position: relative;
  }
</style>
<script>
export default {
  name: 'loader-bar',
    props: {
      timeout: Number
    },
    data: function(){
      return {
        interval: null
      }
    },
    methods: {
      start: function () {
        this.stop();

        var speed = 100;
        var timeout_miliseconds = this.timeout*1000;
        var step_percentage = 100/(timeout_miliseconds/speed);
        var percentage = 0;

        this.interval = setInterval(() => {
          if (percentage >= 100) {
            this.stop();
            this.$emit('ended');
            return false;
          }

          percentage += step_percentage;
          if (percentage > 100) {
            percentage = 100;
          }
          this.$refs.bar.style.width = percentage.toFixed(0)+'%';
        }, speed);
      },
      stop: function(){
        this.$refs.bar.style.width = '0%';
        clearInterval(this.interval);
      }
    }
};
</script>